<template>
    <div style="background:#78143a">
        <div style="width:1400px; margin:0 auto; padding:10px 0; color:#fff;">
            <a-breadcrumb class="page_breadcrumb">
                <a-breadcrumb-item><router-link :to="{name:'menu'}" style="color:#fff">游戏专项</router-link></a-breadcrumb-item>
                <a-breadcrumb-item style="color:#fff">{{parent}}</a-breadcrumb-item>
                <a-breadcrumb-item style="color:#fff">{{name}}</a-breadcrumb-item>
            </a-breadcrumb>
        </div>
        <div class="l12item_ctrl_container">
            <div class="l12item_ctrl">
                <div class="item_box" v-for="(item,index) in data">
                    <h3 v-if="index==0">投放覆盖人群50%以上的道具</h3>
                    <h3 v-if="index==1">投放覆盖人群25-50%的道具</h3>
                    <h3 v-if="index==2">投放覆盖人群25%以下的道具</h3>
                    <ul class="items">
                        <li v-for="it in item" class="item_obj"><span class="name">{{it["item_name"]}}</span><span>{{it["item_id"]}}</span><span>回收率:{{it["cover"]}}%</span><span class="cover" :style="{ height: it['cover'] + 'px', background:it['cover']>=50?'rgb(57, 203, 178)':it['cover']>=25?'#8bbc21':'rgb(247, 163, 92)'}"></span></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment"
import DataTable from '@/components/common/datatable.vue'
import Chart from '@/components/common/chart/chart.vue'
import {ctrlMixin} from '@/utils/ctrlMixin.js'
export default {
    mixins: [ctrlMixin],
    name:'l12item',
    props: ['parent', 'name'],
    components: {
        DataTable,
        Chart,
    },
    mounted(){
        this.selectdate = moment().subtract(1,'day')
        this.getData()
    },
    watch: {
        selectdate(newV) {
            this.getData()
        }
    },
    data() {
        return {
            data: {
            },
            timer: {
                normal: null
            }
        }
    },
    methods: {
        getData() {
            this.loading = true
            this.$service.query(this.queryId, {selectdate:this.selectdate.format('YYYY-MM-DD')}).then((data)=>{
                this.data = data
                this.loading = false
            }).catch((data)=> {
                this.loading = false
            })
        }
    }
}
</script>
<style lang="less" scoped>
@mainColor: #8c9ac1;
@width:1500px;
.l12item_ctrl_container {
    background:#151a40;
    .l12item_ctrl {
        position:relative;
        overflow: hidden;
        width: @width;
        margin:0 auto;
        padding: 0 50px;
        min-height: 100vh;
        color:#fff;
    }

    .item_obj{position:relative; width:102px; margin:10px 20px; padding:14px 0; border:1px solid #dedede; display:inline-block;}
    .item_obj span{position:relative; height:24px; line-height:24px; text-align:center; display:block; overflow:hidden; z-index:1;}
    .item_obj span.name{font-weight:bold;color:#e45353}
    .item_obj span.cover{position:absolute; bottom:0px; width:100px; background:#41cac0; color:#fff; z-index:0;}

    h3 {padding-left: 20px; margin:30px 20px; border-left: 5px solid #78143a; color:#fff;}
}

</style>